import {
  PERFORM_REQUEST,
  PERFORM_REQUEST_FAILURE,
  PERFORM_REQUEST_SUCCESS,
  SET_PAGE
} from './actions.mjs';

const eventListingReducer = (state, action) => {
  switch (action.type) {
    case SET_PAGE:
      return Object.assign({}, state, {
        page: action.page,
      });
    case PERFORM_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
      });
    case PERFORM_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        results: {
          eventsTotal: action.data.eventsTotal,
          eventHits: state.results.eventHits.concat(action.data.eventHits),            
        },
        loading: false,
        error: false,
      });
    case PERFORM_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
      });
    default:
      return state;
  }
};

export default eventListingReducer;
